// extracted by mini-css-extract-plugin
module.exports = {"content":"AddEditDomainPanel_content__pyg3e","badge":"AddEditDomainPanel_badge__ixrOv","link":"AddEditDomainPanel_link__2Uq-6"};